var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "same-type-history-order" },
    [
      _c(
        "el-table",
        {
          staticClass: "myTable",
          attrs: {
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            data: _vm.tableData,
            border: "",
            height: "700",
          },
          on: { "sort-change": _vm.sortChange },
        },
        [
          _c(
            "el-table-column",
            {
              attrs: { prop: "id", fixed: "", width: "110px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#20a8d8" },
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function ($event) {
                                return _vm.jumpDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.id))]
                        ),
                        _vm.$hasBtnRoles(
                          "/count/order-consume-trend-data/index"
                        )
                          ? _c("i", {
                              staticClass: "el-icon el-icon-s-data",
                              staticStyle: {
                                "margin-left": "3px",
                                color: "#409EFF",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toTend(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                      _c("div", [_vm._v(_vm._s(scope.row.card_bin_name))]),
                      _c("div", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.is_invalid_card_bin_order == 1
                                ? "卡类型无关"
                                : ""
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [_vm._v("订单号")]),
                _c("div", [_vm._v("卡类型")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "company_name",
                width: _vm.isSmall ? "110px" : "135px",
                "show-overflow-tooltip": true,
                fixed: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "company-name" },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "#20a8d8" },
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function ($event) {
                                  return _vm.jumpCustomer(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.company_name))]
                          ),
                          _vm.$store.state.user.userInfo.is_sales == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.watchInfo(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(scope.row.customer_type) +
                            "(" +
                            _vm._s(scope.row.nature_str) +
                            ")"
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [_vm._v("客户名称")]),
                _c("div", [_vm._v("客户类型(客户性质)")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { prop: "username", width: _vm.isSmall ? "55px" : "70px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [_vm._v(_vm._s(scope.row.discount))]),
                      _c("div", [_vm._v(_vm._s(scope.row.username))]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [_vm._v("折扣")]),
                _c("div", [_vm._v("负责人")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "cost_rate",
                label: "成本率",
                width: _vm.isSmall ? "80px" : "80px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm._f("removeDecimal")(scope.row.cost_rate))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "成本率 = 修正后真实成本 / 实际分摊抵扣金额",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("成本率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "shou_money",
                width: _vm.isSmall ? "65px" : "90px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm._f("moneyFormat")(scope.row.shou_money))
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm._f("moneyFormat")(scope.row.finance_money))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "应收：订单的实际应收金额；实收：订单的实际回款金额，以财务确认回款为准",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("div", [
                        _c("div", [_vm._v("应收")]),
                        _c("div", [_vm._v("实收")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "sales_commission_rate",
                width: _vm.isSmall ? "60px" : "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(
                              scope.row.sales_commission_rate
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [_vm._v("佣金提成")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "order_commission",
                width: _vm.isSmall ? "60px" : "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneyFormat")(scope.row.order_achievement)
                          )
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneyFormat")(
                              scope.row.real_achievement_rate
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [_vm._v("初始业绩")]),
                _c("div", [_vm._v("实际业绩")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "created_at",
                width: _vm.isSmall ? "85px" : "95px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [_vm._v(_vm._s(scope.row.start_card_date))]),
                      _c("div", [_vm._v(_vm._s(scope.row.end_card_date))]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "售卡有效期：取订单中“已激活”售卡中最早的起始时间、最晚的截止时间。",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("div", [
                        _c("div", [_vm._v("售卡")]),
                        _c("div", [_vm._v("有效期")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "card_sale_points",
                label: "售卡点数",
                sortable: "custom",
                width: "90px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [_vm._v(_vm._s(scope.row.card_sale_points))]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "售卡点数：订单的已售总点数；（已减掉退卡点数）",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("售卡点数")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: { prop: "card_sale_money", label: "已售金额" },
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "finance_rate",
                sortable: "custom",
                widrh: "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.finance_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "回款率：=实收/应收",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("回款率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "consume_rate",
                label: "消费率",
                sortable: "custom",
                widrh: "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.consume_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "消费率：=消费点数/（消费点数+留存点数）",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("消费率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "available_rate",
                label: "留存率",
                sortable: "custom",
                widrh: "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.available_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "留存率：=（留存点数）/ ( 留存点数+消费点数 ) ",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("留存率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "bind_card_rate",
                label: "绑卡率",
                sortable: "custom",
                widrh: "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.bind_card_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "绑卡率：=（已绑定卡数-已绑定且退卡数）/（售卡数-退卡数）",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("绑卡率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "un_use_card_rate",
                label: "全留率",
                sortable: "custom",
                widrh: "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.un_use_card_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "全留率：=（售卡数-有消费记录卡数-有转出记录卡数-有扣费记录卡数-有清余额卡数-退卡数）/（售卡数-退卡数）",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("全留率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "zero_card_rate",
                label: "零留率",
                sortable: "custom",
                widrh: "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.zero_card_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "零留率：=（余额为0卡数-已退卡卡数）/（售卡数-退卡数）；",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("零留率")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "gross_profit",
                label: "含留存毛利",
                width: _vm.isSmall ? "60px" : "85px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("div", [_vm._v(_vm._s(scope.row.gross_profit))])]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "含留存毛利：=实收+额外充值金额+第三方支付金额-销售提成-优惠券成本-服务费成本-修正后真实成本",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("含留")]),
                        _c("br"),
                        _c("span", [_vm._v("存毛利")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "gross_profit_rate",
                label: "含留存毛利率",
                width: _vm.isSmall ? "65px" : "85px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(scope.row.gross_profit_rate)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "含留存毛利率：=含留存毛利/（实收+额外充值金额）",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("含留存")]),
                        _c("br"),
                        _c("span", [_vm._v("毛利率")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              prop: "loser_user",
              label: "交付负责人(成本率目标)",
              width: "88px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.loser_user || "-"))]),
                    _c("div", [
                      scope.row.target_cost_rate ||
                      scope.row.target_cost_rate === 0 ||
                      scope.row.target_cost_rate === "0"
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("removeDecimal")(
                                  scope.row.target_cost_rate
                                )
                              )
                            ),
                          ])
                        : _c("span", [_vm._v("-")]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "prediction_available_rate",
                label: "推测留存率",
                width: _vm.isSmall ? "70px" : "85px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(
                              scope.row.prediction_available_rate
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "推测留存率 = (1) 订单已过期，推测留存率 = 留存率；（2）订单未过期，订单卡类型预设留存率值为空：推测留存率 = 留存率；(3) 订单未过期，且订单留存率<= 订单卡类型预设留存率：推测留存率 = 留存率；(4) 订单未过期，且订单留存率> 订单卡类型预设留存率：推测留存率 = 预设留存率",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("推测")]),
                        _c("br"),
                        _c("span", [_vm._v("留存率")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "prediction_cost",
                label: "推测成本",
                width: "90px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [_vm._v(_vm._s(scope.row.prediction_cost))]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "推测成本 =（ 留存点数 + 消费点数 ）*（ 1 - 推测留存率）* 推测成本率",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("推测成本")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "prediction_gross_profit",
                label: "推测含留存毛利",
                width: _vm.isSmall ? "80px" : "95px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.prediction_gross_profit)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "推测含留存毛利 = 实收 + 推测第三方支付收益 - 销售提成 - 优惠券成本 - 服务费成本 - 推测成本",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("推测含")]),
                        _c("br"),
                        _c("span", [_vm._v("留存毛利")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "prediction_gross_profit_rate",
                label: "推测含留存毛利率",
                width: _vm.isSmall ? "80px" : "95px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("removeDecimal")(
                                scope.row.prediction_gross_profit_rate
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "推测含留存毛利率 = 推测毛利 / 实收",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("推测含留")]),
                        _c("br"),
                        _c("span", [_vm._v("存毛利率")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "consume_gross_profit",
                label: "不含留存毛利",
                width: "100px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.consume_gross_profit)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("span", [_vm._v("不含留")]),
                _c("br"),
                _c("span", [_vm._v("存毛利")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "consume_gross_profit_rate",
                label: "不含留存毛利率",
                width: "100px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeDecimal")(
                              scope.row.consume_gross_profit_rate
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("span", [_vm._v("不含留")]),
                _c("br"),
                _c("span", [_vm._v("存毛利率")]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "transfer_into_points",
                width: _vm.isSmall ? "85px" : "100px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.transfer_into_points)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "转入转出充值点数：=转入点数+充值点数-转出点数-扣费点数",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("div", [
                        _c("div", [_vm._v("转入转出")]),
                        _c("div", [_vm._v("充值点数")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "total_consume_points",
                label: "可消费点数",
                width: _vm.isSmall ? "65px" : "85px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.total_consume_points)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "可消费点数：=消费点数+留存点数；",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("可消")]),
                        _c("br"),
                        _c("span", [_vm._v("费点数")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "consume_points",
                width: _vm.isSmall ? "85px" : "100px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [_vm._v(_vm._s(scope.row.consume_points))]),
                      _c("div", [_vm._v(_vm._s(scope.row.available_points))]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "消费点数：订单的商城消费点数；留存点数：订单的卡剩余未消费点数。（留存点数中包含未激活卡的点数）",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("div", [
                        _c("div", [_vm._v("消费点数")]),
                        _c("div", [_vm._v("留存点数")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "real_order_recharge_money",
                width: _vm.isSmall ? "60px" : "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.real_order_recharge_money)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("div", { staticStyle: { "margin-left": "5px" } }, [
                      _c("div", [_vm._v("额外充")]),
                      _c("div", [_vm._v("值金额")]),
                    ]),
                  ]
                ),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "actual_cost_amount_third_party",
                label: "第三方支付金额",
                width: _vm.isSmall ? "70px" : "90px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.actual_cost_amount_third_party) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "第三方支付金额：订单中卡支付分摊的微信等第三方支付金额（已减掉退款分摊的第三方支付金额）",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("第三方")]),
                        _c("br"),
                        _c("span", [_vm._v("支付金额")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "actual_cost_amount_c",
                width: "90px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.actual_cost_amount_c)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "渠道成本：渠道采购成本减去退款商品的渠道采购成本（即C价格，含运费）",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("渠道成本")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "actual_cost_amount_a",
                label: "基准成本",
                width: "90px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(scope.row.actual_cost_amount_a)),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "基准成本：基准采购成本减去退款商品的基准采购成本（即A价格，含运费；含光影及百味优选加价部分）",
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("基准成本")])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "actual_cost_amount_a0",
                label: "真实成本",
                width: "90px",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.openEditDialog(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.actual_cost_amount_a0))]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "修正后采购成本 = 真实成本 + 修正采购成本",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v("修正后")]),
                        _c("br"),
                        _c("span", [_vm._v("真实成本")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              prop: "online_consume_rate",
              label: "线上消费占比",
              sortable: "custom",
              width: "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("removeDecimal")(scope.row.online_consume_rate)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "rule_diff_rate",
              label: "卡规则差异度",
              width: "110px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("removeDecimal")(scope.row.rule_diff_rate)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "tags",
              label: "标记",
              width: _vm.isSmall ? "100px" : "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._l(scope.row.tags, function (tag) {
                      return _c(
                        "div",
                        { key: tag.id, staticClass: "tag-wrap" },
                        [
                          _c("div", { staticClass: "tag" }, [
                            _vm._v(" " + _vm._s(tag.name) + " "),
                          ]),
                        ]
                      )
                    }),
                    _c(
                      "div",
                      { staticClass: "tag-wrap" },
                      [
                        scope.row.is_follow + "" === "1"
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(" 重点关注 "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "10px",
            "padding-bottom": "10px",
            display: "flex",
            "justify-content": "end",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next, jumper",
              "page-size": 20,
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.currentPage,
            },
            on: { "current-change": _vm.onChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }